import { laptopMax, mobileLargeMax, mobileMax, tabletMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled from 'styled-components';

export const Container = styled.div`
  background: ${(props) => props.theme.backgroundLighter};
  padding: 90px 0;

  @media screen and (${mobileLargeMax}) {
    padding: 80px 0;
  }
`;

export const Content = styled.div`
  display: flex;
  overflow: hidden;
  align-items: center;

  @media screen and (${laptopMax}) {
    flex-wrap: wrap;
    justify-content: center;
  }
`;

export const List = styled.ul`
  padding-inline-start: 20px;
  font-size: 16px;
  padding-top: 10px;
  min-width: 400px;

  @media screen and (${tabletMax}) {
    min-width: 0;
  }
`;

export const ListItem = styled.li`
  margin-bottom: 10px;

  p {
    font-size: 16px;

    @media screen and (${tabletMax}) {
      font-size: 14px;
    }
  }
`;

export const LastListItem = styled.li`
  list-style: none;
  padding-top: 40px;
  margin-left: -20px;
  max-width: 520px;

  @media screen and (${tabletMax}) {
    font-size: 14px;
  }

  @media screen and (${mobileMax}) {
    padding-top: 20px;
    font-size: 14px;
  }

  p {
    font-size: 16px;

    @media screen and (${tabletMax}) {
      font-size: 14px;
    }
  }
`;

export const ImageItem = styled.img`
  width: calc(50% - 30px);
  height: auto;

  @media screen and (${laptopMax}) {
    max-width: 600px;
    width: 100%;
    margin-top: 30px;
  }
`;

export const Buttons = styled.div`
  margin-top: 40px;

  @media screen and (${laptopMax}) {
    margin-bottom: 10px;
    text-align: center;
  }
`;
